import { render, staticRenderFns } from "./GetCategoriesList.vue?vue&type=template&id=1f8dbd52&"
import script from "./GetCategoriesList.vue?vue&type=script&lang=js&"
export * from "./GetCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports